module.exports = __webpack_public_path__ + "static/img/wph.48dcfb7b.png";